module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"select.part.placeholder.default":"เลือกอะไหล่ในระบบ","select.part.custom.placeholder.default":"เพิ่มอะไหล่ที่ไม่มีในระบบ","select.part.mode":"เปลี่ยนรูปแบบการกรอกอะไหล่","select.part.button_text":"กดเพื่อเลือกอะไหล่ในระบบ"}}')
  delete Component.options._Ctor
}
